import { createSelector } from 'reselect';
const customersStateSelector = ({ entities: { customers } = {} }) => customers;
export * from './preferences';
export * from './topics';

export const getCustomer = createSelector(
  [customersStateSelector, (_, { id }) => id],
  (customers, id) => {
    return (customers || {})[id];
  }
);



// WEBPACK FOOTER //
// ./src/redux-modules/customers/selectors/index.js